import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { filter, map, pipe } from 'rxjs';
import { UserState } from './user.state';

import * as _ from 'lodash';
import { UserRole } from 'src/app/core/enums/user/user-role.enum';

export const featureKey = 'user';

export const selectFeature = createFeatureSelector<UserState>(featureKey);

export const userProfile = pipe(
    select(selectFeature),
    filter(state => state.isLoaded),
    map(state => state.profile!)
)

export const userId = pipe(
    userProfile,
    map(profile => profile.id)
)

export const userVersion = pipe(
    userProfile,
    map(profile => profile.version)
)

export const isUserLoggedIn = createSelector(
    selectFeature,
    (state: UserState) => state.isLoaded
);

export const userHasRole = _.memoize((role: UserRole) =>
    createSelector(
        selectFeature,
        (state: UserState) => state.profile?.roles.includes(role)
    )
)

export const userRoles = createSelector(
    selectFeature,
    (state: UserState) => state.profile?.roles
);

export const userPermissions = createSelector(
    selectFeature,
    (state: UserState) => state.profile?.permissions
);

export const userProperties = pipe(
    userProfile,
    map(profile => profile.properties)
);

export const userInterdiction = pipe(
    userProfile,
    map(profile => profile.interdiction)
);